import { xcss } from '@atlaskit/primitives';

export const popupStyles = xcss({
  minWidth: '350px',
  maxWidth: '500px',
  backgroundColor: 'elevation.surface.overlay',
  boxShadow: 'elevation.shadow.overlay',
  zIndex: 'dialog',
  padding: 'space.200',
});

export const popupTitleStyle = xcss({
  flexGrow: 1,
  flexBasis: '0%',
});

export const preserveWhiteSpaceStyle = xcss({
  whiteSpaceCollapse: 'preserve',
});
